import client from '../shopify';
import React from 'react';
import ReactDOM from "react-dom";
import {ProductGrid, FauxGrid} from "../components/ProductGrid";

export default function initializeBirthstone() {
    ReactDOM.render(<BirthstoneSlider/>, document.getElementById('react-node'));
}


class BirthstoneSlider extends React.Component {
    constructor(props) {
        super(props);

        this.QUERYMEMO = {};

        this.state = {
            isLoading: true,
            month: 0,
            products: [],
        };

    }

    componentDidMount() {
        this.fetchProducts(this.state.month);
    }

    fetchProducts(month) {
        let query = `tag:birthstone AND title:${this.numberToStone(month)}*`;

        if (this.QUERYMEMO[query]) {
            this.setState({products: this.QUERYMEMO[query]});
            this.forceUpdate();

        } else {
            this.setState({isLoading: true});

            client.product.fetchQuery({query}).then((products) => {

                console.log(products);

                this.QUERYMEMO[query] = products;
                this.setState({
                    products: products,
                    isLoading: false,
                });
                this.forceUpdate();
            });
        }
    }

    numberToStone(monthNumber) {
        let stones = ['garnet', 'amethyst', 'aquamarine', 'diamond', 'emerald', 'moonstone', 'ruby', 'peridot', 'sapphire', 'opal', 'citrine', 'turquoise'];
        return stones[monthNumber];
    }

    numberToMonth(monthNumber) {
        let stones = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        return stones[monthNumber];
    }

    onChange(e) {
        if (this.state.month !== e) {
            this.setState({month: e});
            this.fetchProducts(e);
        }
    }

    render() {
        let grid = this.state.isLoading ? <FauxGrid perRow={5} count={5}/> : <ProductGrid perRow={5} products={this.state.products}/>;

        return (
            <div className='birthstone-months space-bottom-x3'>
                <Slider onChange={e => this.onChange(e)} month={this.state.month}/>

                <h2>{this.numberToMonth(this.state.month)}</h2>
                <h3>{this.numberToStone(this.state.month)}</h3>

                {grid}
            </div>
        )
    }
}

let Slider = function(props) {
    return (
        <div className='birthstone-slider space-bottom-x2'>
            <div className='birthstone-slider__month'>JAN</div>
            <input
                className='birthstone-slider__input range-months'
                type='range'
                name='timeline'
                min={0}
                max={11}
                step={1}
                value={props.month}
                onChange={(e) => props.onChange(parseInt(e.target.value))}
            />
            <div className='birthstone-slider__month'>DEC</div>
        </div>
    )
};
